import type {Ref} from "vue"

export const useNewsletterStore = defineStore('newsletters', {
  state: () => {
    const state: {
      isLoading: Ref<boolean>
    } = {
      isLoading: ref(false),
    }
    return state
  },
  getters: {
    getIsLoading(state): boolean {
      return state.isLoading
    },
  },
  actions: {
    async addContact(email: string, contactListIds: (string | number)[], recaptchaToken: string): Promise<void> {
      if (!email || !contactListIds || contactListIds.length === 0) {
        return
      }

      const logger = useFrontendLogger()

      let url = `/optin/add-contact`

      const body = {
        email,
        contactListIds,
        recaptchaToken,
      }

      if (import.meta.client) {
        try {
          this.isLoading = true

          const response: any = await $fetch(url, {
            method: 'POST',
            body
          })

          this.isLoading = false
          if (response?.status !== "created") {
            logger?.error('useNewsletterStore:addContact:client - error', {
              errorDetail: response,
              addContactUrl: url,
              addContactBody: body,
              addContactResponse: response,
            })
          }
          return response
        } catch (e) {
          logger?.error('useNewsletterStore:addContact:client - exception', {
            errorDetail: e,
            addContactUrl: url,
            addContactBody: body
          })
        } finally {
          this.isLoading = false
        }
      }
    },
  }
})
